import * as React from 'react';
import styled from 'styled-components'
import {ConstBorderRound, ConstColor, ConstFontStyle} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
}

const LabelJobDefault: React.FC<IProps> = (props) => {

    const { ...SpanProps } = props;

    return (<span {...SpanProps} />)

};

const LabelJob = styled(LabelJobDefault)`
    color: ${ConstColor.Corporate};
    border: 1px solid ${ConstColor.Corporate};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    font-style: normal;
    font-weight: ${ConstFontStyle.LabelJob.fontWeight};
    font-size: ${ConstFontStyle.LabelJob.fontSize};
    line-height: ${ConstFontStyle.LabelJob.lineHeight};
    
    padding: 3px 10px;
`;

export default LabelJob;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/label/label_job.tsx